const NavBar: React.FC<{
    templateTypeTab: 'PRINT' | 'SEND';
    onTemplateTypeChange: (type: 'PRINT' | 'SEND') => void;
}> = ({ templateTypeTab, onTemplateTypeChange }) => {
    return (
        <div className="flex items-center justify-center space-x-8 font-400 text-14 bg-darwin-neutral-100">
            <button
                className={`${
                    templateTypeTab === 'PRINT' && 'active-button'
                } flex items-center space-x-8 px-15 py-10`}
                onClick={() => {
                    onTemplateTypeChange('PRINT');
                }}
            >
                <span className="text-darwin-neutral-700 md:flex">Print Rx Template</span>
            </button>
            <button
                className={`${
                    templateTypeTab === 'SEND' && 'active-button'
                } flex items-center space-x-8 px-15 py-10`}
                onClick={() => {
                    onTemplateTypeChange('SEND');
                }}
            >
                <span className="text-darwin-neutral-700 md:flex">Digital Rx Template</span>
            </button>
        </div>
    );
};

export default NavBar;
